module.exports = __webpack_public_path__ + "media/src/images/icons/reward/finish-flag-61bf03d0c152a63852ebce6e9d68f9fb.svg";